export default "__VITE_ASSET__BpnuGJTX__"